<ng-container *ngIf="!legacyList">
  <form
    [formGroup]="form"
    class="mb-0"
    novalidate
  >
    <ng-container *ngIf="orientation === 'horizontal'">
      <!-- Radio/Checkbox horizontal layout -->
      <div
        *ngIf="
          listEntity.controlType.toString() === 'radio'
          || listEntity.controlType.toString() === 'checkbox'
        "
        class="form-group"
        [ngClass]="{ 'mb-0': !showLabel }"
      >
        <div class="d-flex flex-wrap align-items-center">
          <label
            *ngIf="showLabel"
            [class.mr-3]="!templateForPermitForm"
            class="mb-0"
            [ngClass]="{ 'font-weight-bold': entity.isRequired }"
          >
            {{ showLabel ? entity?.label : '' }}
          </label>
          <!-- WHEN templateForPermitForm use common components -->
          <ng-container *ngIf="templateForPermitForm">
            <!-- RADIO -->
            <ng-container *ngIf="listEntity.controlType.toString() === 'radio'" >
              <div class="mt-2">
                <wm-common-radio
                  [data]="getCommonRadioData()"
                  [formControlName]="entity.templateCode"
                  (valueChange)="handleRadioChange($event, entity)">
                </wm-common-radio>
                <wm-control-message
                  [control]="form.controls[entity.templateCode]"
                ></wm-control-message>
              </div>
            </ng-container>

            <!-- CHECKBOX: render a common-checkbox per availableListItem -->
            <ng-container *ngIf="listEntity.controlType.toString() === 'checkbox'">
              <div class="d-flex flex-wrap">
                <ng-container [formGroup]="checkboxGroup">
                  <ng-container *ngFor="let ali of listEntity.availableListItems; let i = index">
                    <wm-common-checkbox
                      [formControlName]="ali.id"
                      [data]="{
                        label: ali.text,
                        name: listEntity.templateCode + '_' + ali.id,
                        checked: isItemSelected(listEntity, ali),
                        required: entity.isRequired,
                        showRequiredStar: listEntity.availableListItems.length === 1 && entity.isRequired
                      }"
                    ></wm-common-checkbox>
                  </ng-container>
                </ng-container>
              </div>
              <wm-control-message [control]="form.controls[entity.templateCode]"></wm-control-message>
            </ng-container>
          </ng-container>

          <!-- WHEN !templateForPermitForm  -->
          <ng-container *ngIf="!templateForPermitForm" class="d-flex flex-wrap align-items-center">
            <div
              class="custom-control mr-3"
              [ngClass]="'custom-' + listEntity.controlType"
              *ngFor="let ali of listEntity.availableListItems"
            >
              <input
                class="custom-control-input"
                [type]="listEntity.controlType"
                (change)="addItem($event.target.checked, ali)"
                [formControlName]="entity.templateCode"
                [checked]="isSelected(ali)"
                [name]="listEntity.templateCode"
                [id]="listEntity.templateCode + ali.id"
                [value]="ali.value"
                [required]="entity.isRequired"
              />
              <label
                class="custom-control-label"
                [for]="listEntity.templateCode + ali.id"
              >
                {{ ali.text }}
              </label>
            </div>
          </ng-container>
        </div>
      </div>

      <!-- Dropdown/Multi-select horizontal layout -->
      <div *ngIf="
          listEntity.controlType.toString() === 'multi-select'
          || listEntity.controlType.toString() === 'dropdown'
        "
        class="form-group row"
        [ngClass]="{ 'mb-0': !showLabel }"
      >
        <label
          *ngIf="showLabel"
          [for]="entity.templateCode"
          class="col-sm-3"
          [ngClass]="{ 'font-weight-bold': entity.isRequired }"
        >
          {{ showLabel ? entity?.label : '' }}
        </label>

        <!-- COMPONENT FIX: Only apply col-12 if showLabel is false AND it is the Janus layout. Otherwise, fall back to empty. -->
        <div [ngClass]="showLabel ? 'col-sm-9' : (templateForPermitForm ? 'col-12' : '')">

          <ng-container
            *ngIf="
              listEntity.controlType.toString() === 'dropdown'
              && templateForPermitForm
            "
          >
            <div class="mt-2">
              <wm-common-dropdown
                [data]="commonDropdownData"
                [formControlName]="entity.templateCode"
                (valueChange)="handleDropdownChange($event, entity)">
              </wm-common-dropdown>
            </div>
            <wm-control-message style="display: block; padding-top: 8px;" [control]="form.controls[entity.templateCode]"></wm-control-message>
          </ng-container>

          <ng-container
            *ngIf="
              listEntity.controlType.toString() === 'dropdown'
              && !templateForPermitForm
            "
          >
            <select
              class="form-control"
              [id]="entity.templateCode"
              [name]="entity.templateCode"
              [formControlName]="entity.templateCode"
              (change)="addItemById(true, $event.target.value)"
              [(ngModel)]="selectedDropdownItemId"
              [required]="entity.isRequired"
            >
              <option
                [selected]="!selectedEntityValues || selectedEntityValues.length < 1"
                value=""
                [disabled]="true"
              >
                Select Item...
              </option>
              <option
                *ngFor="let ali of listEntity.availableListItems"
                [value]="ali.id"
                [selected]="isSelected(ali)"
              >
                {{ ali.text }}
              </option>
            </select>
          </ng-container>

          <ng-container *ngIf="listEntity.controlType.toString() === 'multi-select'">
            <select
              class="form-control"
              [id]="entity.templateCode"
              [name]="entity.templateCode"
              [formControlName]="entity.templateCode"
              (change)="addItemById(true, $event.target.value)"
              [(ngModel)]="selectedDropdownItemId"
              [required]="entity.isRequired"
            >
              <option
                [selected]="!selectedEntityValues || selectedEntityValues.length < 1"
                value=""
                [disabled]="true"
              >
                Select Item...
              </option>
              <option
                *ngFor="let ali of listEntity.availableListItems"
                [value]="ali.id"
                [selected]="isSelected(ali)"
              >
                {{ ali.text }}
              </option>
            </select>
          </ng-container>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="orientation === 'vertical'">
      <br />
      <!-- Radio/Checkbox vertical layout -->
      <div
        *ngIf="
          listEntity.controlType.toString() === 'radio'
          || listEntity.controlType.toString() === 'checkbox'
        "
      >
        <wm-de-label
          *ngIf="showLabel"
          [entity]="entity"
          [for]="entity.templateCode"
        ></wm-de-label>

        <!-- PERMIT TEMPLATE: common controls -->
        <ng-container *ngIf="templateForPermitForm">
          <ng-container
            *ngIf="listEntity.controlType.toString() === 'radio'"
          >
            <div class="mt-2">
              <wm-common-radio
                [data]="getCommonRadioData()"
                [formControlName]="entity.templateCode"
                (valueChange)="handleRadioChange($event, entity)"
              ></wm-common-radio>
              <wm-control-message [control]="form.controls[entity.templateCode]"></wm-control-message>
            </div>
          </ng-container>

          <ng-container *ngIf="listEntity.controlType.toString() === 'checkbox'">
            <div class="d-flex flex-column">
              <ng-container [formGroup]="checkboxGroup">
                <ng-container *ngFor="let ali of listEntity.availableListItems; let i = index">
                  <wm-common-checkbox
                    [formControlName]="ali.id"
                    [data]="{
                      label: ali.text,
                      name: listEntity.templateCode + '_' + ali.id,
                      checked: isItemSelected(listEntity, ali),
                      required: entity.isRequired,
                      showRequiredStar: listEntity.availableListItems.length === 1 && entity.isRequired
                    }"
                  ></wm-common-checkbox>
                </ng-container>
              </ng-container>
            </div>
            <wm-control-message [control]="form.controls[entity.templateCode]"></wm-control-message>
          </ng-container>
        </ng-container>

        <!-- ORIGINAL inputs when not permit template (unchanged) -->
        <ng-container *ngIf="!templateForPermitForm">
          <div
            class="custom-control"
            [ngClass]="'custom-' + listEntity.controlType"
            *ngFor="let ali of listEntity.availableListItems"
          >
            <input
              class="custom-control-input"
              [type]="listEntity.controlType"
              (change)="addItem($event.target.checked, ali)"
              [formControlName]="entity.templateCode"
              [checked]="isSelected(ali)"
              [name]="listEntity.templateCode"
              [id]="listEntity.templateCode + ali.id"
              [value]="ali.value"
              [required]="entity.isRequired"
            />
            <label
              class="custom-control-label"
              [for]="listEntity.templateCode + ali.id"
            >
              {{ ali.text }}
            </label>
          </div>
        </ng-container>
      </div>

      <!-- Dropdown (vertical) - unchanged except wm-common-dropdown branch preserved -->
      <div
        *ngIf="
          listEntity.controlType.toString() === 'dropdown'
          && templateForPermitForm
        "
      >
        <wm-de-label
          *ngIf="showLabel"
          [entity]="entity"
          [for]="entity.templateCode"
        ></wm-de-label>
        <div class="mt-2">
          <wm-common-dropdown
            [data]="commonDropdownData"
            [formControlName]="entity.templateCode"
            (valueChange)="handleDropdownChange($event, entity)"
          >
          </wm-common-dropdown>
        </div>
        <wm-control-message style="display: block; padding-top: 8px;" [control]="form.controls[entity.templateCode]"></wm-control-message>
      </div>

      <div
        *ngIf="
          listEntity.controlType.toString() === 'dropdown' &&
          !templateForPermitForm
        "
      >
        <wm-de-label
          *ngIf="showLabel"
          [entity]="entity"
          [for]="entity.templateCode"
        ></wm-de-label>
        <select
          class="form-control"
          [id]="entity.templateCode"
          [name]="entity.templateCode"
          [formControlName]="entity.templateCode"
          (change)="addItemById(true, $event.target.value)"
          [(ngModel)]="selectedDropdownItemId"
          [required]="entity.isRequired"
        >
          <option
            [selected]="!selectedEntityValues || selectedEntityValues.length < 1"
            value=""
            [disabled]="true"
          >
            Select Item...
          </option>
          <option
            *ngFor="let ali of listEntity.availableListItems"
            [value]="ali.id"
            [selected]="isSelected(ali)"
          >
            {{ ali.text }}
          </option>
        </select>
      </div>
    </ng-container>
  </form>
</ng-container>

<!-- We don't want to interfere with migrated list data entities that we created without giving ids to its ListItems -->

<ng-container *ngIf="legacyList">
  <form
    [formGroup]="form"
    class="mb-0"
    novalidate
  >
    <ng-container *ngIf="orientation === 'horizontal'">
      <!-- Legacy Radio/Checkbox horizontal layout -->
      <div
        *ngIf="
          listEntity.controlType.toString() === 'radio'
          || listEntity.controlType.toString() === 'checkbox'
        "
        class="form-group"
        [ngClass]="{ 'mb-0': !showLabel }"
      >
        <div class="d-flex flex-wrap align-items-center">
          <label
            *ngIf="showLabel"
            class="mr-3 mb-0"
            [ngClass]="{ 'font-weight-bold': entity.isRequired }"
          >
            {{ showLabel ? entity?.label : '' }}
          </label>

          <!-- legacy PERMIT: common components -->
          <ng-container *ngIf="templateForPermitForm">
            <ng-container *ngIf="listEntity.controlType.toString() === 'radio'" >
              <div class="mt-2">
                <wm-common-radio
                  [data]="getCommonRadioData()"
                  [formControlName]="entity.templateCode"
                  (valueChange)="handleRadioChange($event, entity)"
                ></wm-common-radio>
                <wm-control-message [control]="form.controls[entity.templateCode]"></wm-control-message>
              </div>
            </ng-container>

            <ng-container *ngIf="listEntity.controlType.toString() === 'checkbox'">
              <div class="d-flex flex-wrap">
                <ng-container [formGroup]="checkboxGroup">
                  <ng-container *ngFor="let ali of listEntity.availableListItems; let i = index">
                    <wm-common-checkbox
                      [formControlName]="ali.id"
                      [data]="{
                        label: ali.text,
                        name: listEntity.templateCode + '_' + ali.id,
                        checked: isItemSelected(listEntity, ali),
                        required: entity.isRequired,
                        showRequiredStar: listEntity.availableListItems.length === 1 && entity.isRequired
                      }"
                    ></wm-common-checkbox>
                  </ng-container>
                </ng-container>
              </div>
              <wm-control-message [control]="form.controls[entity.templateCode]"></wm-control-message>
            </ng-container>
          </ng-container>

          <!-- legacy ORIGINAL (unchanged) -->
          <ng-container *ngIf="!templateForPermitForm">
            <div
              class="custom-control mr-3"
              [ngClass]="'custom-' + listEntity.controlType"
              *ngFor="let s of listEntity.availableListItems"
            >
              <input
                class="custom-control-input"
                [type]="listEntity.controlType"
                (change)="addLegacyItem($event.target.checked, s.value)"
                [formControlName]="entity.templateCode"
                [checked]="isLegacyItemSelected(s)"
                [name]="listEntity.templateCode"
                [id]="listEntity.templateCode + s.value"
                [value]="s.value"
                [required]="entity.isRequired"
              />
              <label class="custom-control-label" [for]="listEntity.templateCode + s.value">
                {{ s.text }}
              </label>
            </div>
          </ng-container>
        </div>
      </div>

      <!-- legacy dropdown/multi-select preserved same as before (unchanged) -->
      <div
        *ngIf="
          listEntity.controlType.toString() === 'multi-select'
          || listEntity.controlType.toString() === 'dropdown'
        "
        class="form-group row"
        [ngClass]="{ 'mb-0': !showLabel }"
      >
        <label
          *ngIf="showLabel"
          [for]="entity.templateCode"
          class="col-sm-3"
          [ngClass]="{ 'font-weight-bold': entity.isRequired }"
        >
          {{ showLabel ? entity?.label : '' }}
        </label>

        <!-- COMPONENT FIX: Only apply col-12 if showLabel is false AND it is the Janus layout. Otherwise, fall back to empty. -->
        <div [ngClass]="showLabel ? 'col-sm-9' : (templateForPermitForm ? 'col-12' : '')">

          <ng-container
            *ngIf="
              listEntity.controlType.toString() === 'dropdown' &&
              templateForPermitForm
            "
          >
            <div class="mt-2">
              <wm-common-dropdown
                [data]="commonDropdownData"
                [formControlName]="entity.templateCode"
                (valueChange)="handleDropdownChange($event, entity)"
              ></wm-common-dropdown>
            </div>
            <wm-control-message style="display: block; padding-top: 8px;" [control]="form.controls[entity.templateCode]"></wm-control-message>
          </ng-container>

          <ng-container
            *ngIf="
              listEntity.controlType.toString() === 'dropdown' &&
              !templateForPermitForm
            "
          >
            <select
              class="form-control"
              [id]="entity.templateCode"
              [name]="entity.templateCode"
              [formControlName]="entity.templateCode"
              (change)="addLegacyItem(true, $event.target.value)"
              [required]="entity.isRequired"
            >
              <option
                [selected]="!selectedEntityValues || selectedEntityValues.length < 1"
                value=""
                [disabled]="true"
              >
                Select Item...
              </option>
              <option
                *ngFor="let s of listEntity.availableListItems"
                [value]="s.value"
                [selected]="isLegacyItemSelected(s)"
              >
                {{ s.text }}
              </option>
            </select>
          </ng-container>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="orientation === 'vertical'">
      <br />
      <div
        *ngIf="
          listEntity.controlType.toString() === 'radio'
          || listEntity.controlType.toString() === 'checkbox'
        "
      >
        <wm-de-label
          *ngIf="showLabel"
          [entity]="entity"
          [for]="entity.templateCode"
        ></wm-de-label>
        <ng-container *ngIf="templateForPermitForm">
          <ng-container *ngIf="listEntity.controlType.toString() === 'radio'">
            <div class="mt-2">
              <wm-common-radio
                [data]="getCommonRadioData()"
                [formControlName]="entity.templateCode"
                (valueChange)="handleRadioChange($event, entity)"
              ></wm-common-radio>
              <wm-control-message [control]="form.controls[entity.templateCode]"></wm-control-message>
            </div>
          </ng-container>

          <ng-container *ngIf="listEntity.controlType.toString() === 'checkbox'">
            <div class="d-flex flex-column">
              <ng-container [formGroup]="checkboxGroup">
                <ng-container *ngFor="let ali of listEntity.availableListItems; let i = index">
                  <wm-common-checkbox
                    [formControlName]="ali.id"
                    [data]="{
                      label: ali.text,
                      name: listEntity.templateCode + '_' + ali.id,
                      checked: isItemSelected(listEntity, ali),
                      required: entity.isRequired,
                      showRequiredStar: listEntity.availableListItems.length === 1 && entity.isRequired
                    }"
                  ></wm-common-checkbox>
                </ng-container>
              </ng-container>
            </div>
            <wm-control-message [control]="form.controls[entity.templateCode]"></wm-control-message>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="!templateForPermitForm">
          <div
            class="custom-control"
            [ngClass]="'custom-' + listEntity.controlType"
            *ngFor="let s of listEntity.availableListItems"
          >
            <input
              class="custom-control-input"
              [type]="listEntity.controlType"
              (change)="addLegacyItem($event.target.checked, s.value)"
              [formControlName]="entity.templateCode"
              [checked]="isLegacyItemSelected(s)"
              [name]="listEntity.templateCode"
              [id]="listEntity.templateCode + s.value"
              [value]="s.value"
              [required]="entity.isRequired"
            />
            <label class="custom-control-label" [for]="listEntity.templateCode + s.value">
              {{ s.text }}
            </label>
          </div>
        </ng-container>
      </div>

      <!-- legacy dropdown vertical preserved -->
      <div
        *ngIf="
          listEntity.controlType.toString() === 'dropdown'
          && templateForPermitForm
        "
      >
        <wm-de-label
          *ngIf="showLabel"
          [entity]="entity"
          [for]="entity.templateCode"
        ></wm-de-label>
        <div class="mt-2">
          <wm-common-dropdown
            [data]="commonDropdownData"
            [formControlName]="entity.templateCode"
            (valueChange)="handleDropdownChange($event, entity)">
          </wm-common-dropdown>
        </div>
        <!-- COMPONENT FIX: Added inline styles for validation message padding -->
        <wm-control-message style="display: block; padding-top: 8px;" [control]="form.controls[entity.templateCode]"></wm-control-message>
      </div>

      <div
        *ngIf="
          listEntity.controlType.toString() === 'dropdown' &&
          !templateForPermitForm
        "
      >
        <wm-de-label
          *ngIf="showLabel"
          [entity]="entity"
          [for]="entity.templateCode"
        ></wm-de-label>
        <select
          class="form-control"
          [id]="entity.templateCode"
          [name]="entity.templateCode"
          [formControlName]="entity.templateCode"
          (change)="addLegacyItem(true, $event.target.value)"
          [required]="entity.isRequired"
        >
          <option
            [selected]="!selectedEntityValues || selectedEntityValues.length < 1"
            value="" [disabled]="true"
          >
            Select Item...
          </option>
          <option
            *ngFor="let s of listEntity.availableListItems"
            [value]="s.value"
            [selected]="isLegacyItemSelected(s)"
          >
            {{ s.text }}
          </option>
        </select>
      </div>
    </ng-container>
  </form>
</ng-container>
